export default __webpack_public_path__ + "media/images/logo-9d29033f497673b4a06272576664df9d.svg";